export const defaultReports = [{
    name: "گزارش کالاهای پرفروش",
    text: ' حاشیه سود، حداکثر حاشیه',
    date: "1399/11/1"
}, { name: "گزارش کالاهای در باکس", text: 'موقعیت، تعداد رقیب' }, {
    name: "گزارش استراتژی بالاترین قیمت",
    text: 'استراتژی'
}, { name: "گزارش نوع رقابت هوشمند", text: 'نوع رقابت، فعال‌سازی مجدد' }]
export const productInfo = [
    { name: "نام کالا", value: "productNewName", required: "true" },
    { name: "نام کالا در دیجی‌کالا", value: "productName", required: "true" },
    { name: "کد کالا", value: "DKP", required: "true" },
    { name: "کد تنوع", value: "DKPC", required: "true" },
    { name: "کد فروشنده", value: "supplierCode", required: "true" },
    { name: "برند", value: "brand", type: "checkbox", required: "true" },
    { name: "گروه کالا", value: "productGroup", type: "checkbox", required: "true" },
    { name: "پنل فروشنده", value: "channel", type: "checkbox", required: "true" },
    // {name:"میانگین فروش کالا",value:"productInfo_sellAvg",type:"range",unitLabel:"عدد بر هفته"},
    // {name:"موقعیت",value:"productInfo_status",type:"toggle",dropdownContent:[{name:"",value:""},{name:"",value:""},]},
    // {name:"تعداد رقیب",value:"productInfo_Competitor",type:"range", unitLabel:"عدد"},
    {
        name: "وضعیت فروش",
        value: "salesStatus",
        type: "toggle",
        dropdownContent: [{ name: "فعال", value: true }, { name: "غیرفعال", value: false },]
    },
    // {name:"ارسال توسط",value:"shippingOptions",type:"checkbox",dropdownContent:[{ name: "دیجی‌کالا", value: 'digikala' }, { name: "هر دو", value: 'both' }]},
]
export const Pricing = [
    { name: "قیمت فروش", value: "salesPrice", type: "range", unitLabel: "ریال" },
    { name: "حداقل قیمت", value: "minPrice", type: "range", unitLabel: "ریال" },
    { name: "حداکثر قیمت", value: "maxPrice", type: "range", unitLabel: "ریال" },
    { name: "قیمت مرجع", value: "resourcePrice", type: "range", unitLabel: "ریال" },
    { name: "قیمت خرید", value: "purchasePrice", type: "range", unitLabel: "ریال" },
]
export const Inventory = [
    { name: "موجودی قابل فروش", value: "stock", type: "range", unitLabel: "ریال" },
    { name: "موجودی دیجی‌کالا", value: "digikalaStock", type: "range", unitLabel: "تعداد" },
    { name: "موجودی فروشنده", value: "sellerStock", type: "range", unitLabel: "تعداد" },
    { name: "تعداد رزرو", value: "reservedStock", type: "range", unitLabel: "ریال" },
]
export const RobotData = [
    {
        name: "وضعیت ربات",
        value: "robotStatus",
        type: "toggle",
        dropdownContent: [{ name: "فعال", value: true }, { name: "غیرفعال", value: false }]
    },
    {
        name: "فعال‌سازی مجدد", value: "reactivation", type: "checkbox", dropdownContent: [
            // { name: "با بیشترین سود", value: 'maximumProfit' }
            , { name: "غیرفعال", value: 'disable' }
            // , { name: "هوشمند", value: 'smart' }
        ]
    },
    {
        name: "استراتژی",
        value: "pricingStrategy",
        type: "checkbox",
        dropdownContent: [
            {
                name: "باکس هوشمند",
                value: 'aiSmart'
            },
            {
                name: "کمترین قیمت",
                value: 'lowestPrice'
            },
            {
                name: "موجود در باکس(پلکانی)",
                value: 'boxStep'
            },
            {
                name: "موجود در باکس(لحظه‌ای)",
                value: 'boxMoment'
            },
            // { name: "موجود در باکس(با کمترین قیمت)", value: 'boxLowestPrice'},{ name: "موجود در باکس(لحظه‌ای)", value: 'boxMoment' }, { name: "رقابت هوشمند", value: 'smart' }
        ]
    },
    // {
    //     name: "نوع فروش", value: "sellingType", type: "checkbox", dropdownContent: [
    //         // { name: "فروش ویژه", value: 'special' },
    //         {name: "فروش عادی", value: 'normal'},
    //         //  { name: "فروش هوشمند", value: 'smart' },
    //     ]
    // },
    { name: "حداقل حاشیه سود", value: "minimumProfitMargin", type: "range", unitLabel: "ریال" },
    { name: "حداکثر حاشیه سود", value: "maximumProfitMargin", type: "range", unitLabel: "ریال" },
    // {name:"نمودار وضعیت سود",value:"",type:"range",unitLabel:"درصد"},
    {
        name: "افزایش قیمت", value: "priceIncrease", type: "checkbox", dropdownContent: [
            { name: "آزاد ", value: 'free' },
            //  { name: "محدود به حداکثر سود", value: 'maximumProfit' }, { name: "محدود به قیمت مرجع", value: 'referencePrice' }
        ]
    },
    // {
    //     name: "نوع رقابت", value: "competitionType", type: "checkbox", dropdownContent: [
    //         {name: "ثابت", value: 'fix'},
    //         //  { name: "چرخشی", value: 'cycle' }
    //     ]
    // },
    // {name:"آخرین به‌روزرسانی",value:"lastGetToChangePrice",type:"range",unitLabel:"ریال"},

]
//{name:"d"},{name:"a"},{name:"s"},{name:"e"},{name:"t"}
export const withSortFeilds = [
    "minimumProfitMargin",
    "maximumProfitMargin",
    //   "lastGetToChangePrice",
    //   "productInfo_Competitor",
    //   "productInfo_sellAvg"
]